import { CircularProgressBar } from './CircularProgressBar';
import React from 'react';

type Props = {
    left: React.ReactNode;
    center: React.ReactNode;
    right: React.ReactNode;
    footer: React.ReactNode;
    progress: number;
    progressColors?: { foreground: string; background: string };
};

export function ProgressDisplay({
    left,
    center,
    right,
    footer,
    progress,
    progressColors = {
        foreground: 'var(--color-action-orange)',
        background: 'var(--color-action-orange-light)',
    },
}: Props) {
    return (
        <div className="mt-8 w-full rounded-md px-4 text-center sm:text-left lg:mt-0 lg:h-60">
            <div className="flex flex-row items-center gap-4 align-middle sm:justify-between lg:items-end">
                {/* Left */}
                <div className="flex flex-1 flex-col items-center text-center lg:items-start lg:text-start">
                    {left}
                </div>

                {/* Center */}
                <div className="flex flex-1 items-center justify-center sm:block">
                    {/* Show CIRCLE on small screens */}
                    <div className="block lg:hidden">
                        <div className="flex h-full items-center justify-center">
                            <CircularProgressBar
                                radius={80}
                                stroke={5}
                                progress={progress}
                                className="text-xs"
                                progressColors={progressColors}
                            >
                                <div className="flex flex-col items-center justify-center leading-tight">
                                    {center}
                                </div>
                            </CircularProgressBar>
                        </div>
                    </div>

                    {/* Show HORIZONTAL BAR on sm+ screens */}
                    <div className="ns:hidden hidden w-full text-center lg:block">
                        {center}
                    </div>
                </div>

                {/* Right */}
                <div className="flex flex-1 flex-col items-center text-center lg:items-end lg:text-right">
                    {right}
                </div>
            </div>

            <div
                style={{ backgroundColor: progressColors.background }}
                className="relative mt-4 hidden h-1 rounded-sm lg:block"
            >
                <div
                    className="absolute top-0 left-0 h-1 rounded-sm"
                    style={{
                        backgroundColor: progressColors.foreground,
                        width: `${Math.min(progress * 100, 100)}%`,
                    }}
                />
            </div>

            {/* Footer */}
            {footer && (
                <div className="text-primary-blue mt-4 flex items-center gap-2 text-sm font-bold lg:justify-start">
                    {footer}
                </div>
            )}
        </div>
    );
}
